import { createInstance } from "i18next"
import { initReactI18next } from "react-i18next"
import it from "./it.json"
import en from "./en.json"
import { matchPath } from "react-router-dom"

const DEFAULT_LANG = "it"
const LANGS = ["it", "en"]
export function createI18n(pathname: string) {
  const i18nInstance = createInstance()
  i18nInstance
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: {
        it: {
          translation: it,
        },
        en: {
          translation: en,
        },
      },
      lng: getStartLang(pathname), // if you're using a language detector, do not define the lng option
      fallbackLng: "en",

      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      },
    })

  return i18nInstance
}

export function getLangFromParam(langParam: string) {
  const langParamLower = langParam.toLowerCase()
  // Lang is on of configure...
  if (LANGS.includes(langParamLower)) {
    return langParamLower
  }
  // Fallback 2 default one
  return DEFAULT_LANG
}

export function getStartLang(pathname: string) {
  const langMatch = matchPath("/:lang/*", pathname)
  if (langMatch) {
    return getLangFromParam(langMatch.params.lang!)
  }
  return DEFAULT_LANG
}
